import classNames from 'classnames';
import Address from './components/address';
import moment from 'jalali-moment';
import Footer from './components/footer';
import {toPersianQuality} from 'utilities/helper/toPersianQuality';

interface ICardProps {
  title: string;
  icon: string | null;
  state: string | null;
  city: string | null;
  createdAt: Date;
  quality: string;
  hidePhoneNumber: boolean;
  type: string;
  guid: string;
  app: string;
  post_type: string;
}

const Card = ({
  title,
  app,
  icon,
  state,
  city,
  createdAt,
  quality,
  hidePhoneNumber,
  guid,
  post_type,
  type,
}: ICardProps) => {
  return (
    <>
      <div className="p-3 w-full rounded-[10px] shadow-[0_2.4049079418182373px_9.61963176727295px_0px_rgba(0,0,0,0.1)]">
        <div className="flex justify-between">
          <div>
            <span className="flex items-center">
              <i className={classNames(icon, 'text-gray-5')}></i>{' '}
              <b
                dir="rtl"
                className="text-black ps-1 overflow-hidden max-w-[256px] truncate"
              >
                {title}
              </b>
            </span>
          </div>
          <div>
            <small
              className={classNames(
                ' px-2 py-1 rounded-full whitespace-nowrap 	text-sm',
                quality === 'class_1'
                  ? ' bg-warning-1 text-warning-2'
                  : quality === 'class_2'
                  ? ' bg-natural-3 text-natural-4'
                  : quality === 'class_3'
                  ? 'bg-error-1 text-warning-2'
                  : ' bg-Cyan-chat-6 text-green-grade',
              )}
            >
              درجه {toPersianQuality[quality].degree}
            </small>
          </div>
        </div>
        <div className="pt-5">
          <Address
            dateTime={moment(new Date(createdAt))
              .locale('fa')
              .format('YYYY/MM/DD')}
            title={`${state}${city ? ` , ${city}` : ''}`}
          />
        </div>
        <div className="mt-5">
          <Footer
            hidePhoneNumber={hidePhoneNumber}
            guid={guid}
            type={type}
            app={app}
            post_type={post_type}
          />
        </div>
      </div>
    </>
  );
};

export default Card;
